import React from 'react';
import PropTypes from 'prop-types';

import { titles } from 'utils/formData';
import { texts } from 'utils/languages/fr';
import { CustomSelect } from 'components';
import { MenuItem } from '@mui/material';

const CivilitySelect = ({ value, onChange, ...rest }) => (
    <CustomSelect value={value} onChange={onChange} label={texts.CIVILITE} {...rest}>
        {Object.keys(titles).map(key => (
            <MenuItem key={key} value={key !== 'UNKNOWN' ? titles[key] : key}>
                {titles[key]}
            </MenuItem>
        ))}
    </CustomSelect>
);

CivilitySelect.propTypes = { value: PropTypes.string, onChange: PropTypes.func.isRequired };

export default CivilitySelect;
